module.exports = __webpack_public_path__ + "img/music-player-play-circle.651a5c23.svg";